import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery, RichTextArea } from '@grandvisionhq/common';

const PupillaryDistanceContent = ({ className , description , image  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    return /*#__PURE__*/ React__default.createElement("section", {
        className: classnames('pupillary-distance-content', className)
    }, image && /*#__PURE__*/ React__default.createElement("img", {
        className: "pupillary-distance-content__image",
        src: isSmallScreen ? image.mobileUrl : image.url,
        alt: image.description || ''
    }), description && /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(RichTextArea, {
        className: "pupillary-distance-content__description",
        content: description
    })));
};

export { PupillaryDistanceContent };
//# sourceMappingURL=PupillaryDistanceContent.js.map
